export const documentsComplete = ({ context }) => !!context.documentsUploaded;
export const contractSigned = ({ context }) => !!context.contractSigned;
//# sourceMappingURL=onboarding.js.map